var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-root"},[_c('router-view'),(_vm.isAdmin)?_c('a',{staticClass:"button",on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.logoutStr))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }